import React from "react";

export default function Marquee({ items, bg = "bg-brand-yellow" }) {
  const row = [...items, ...items];
  return (
    <div className={`${bg} border-y-2 border-ink overflow-hidden py-3`} data-testid="marquee">
      <div className="marquee">
        {row.map((t, i) => (
          <span key={i} className="font-display font-bold text-lg sm:text-xl px-6 whitespace-nowrap flex items-center gap-6">
            {t} <span className="text-brand-pink">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
